export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/logo.svg?dfa25b22cdb9dbcf50ce8101e13fb686";